import { Injectable } from '@angular/core';
import {
  EquipClassFacadeBase,
  AppState,
  equipClassSelectors,
} from '@app/state';
import { Store, select } from '@ngrx/store';
import { EquipmentClass, EquipmentType, EquipmentClassVM } from '@app/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  currentEquipClassTypes,
  equipmentClassVM,
} from '@app/state/equipment-class.join-selectors';

@Injectable({ providedIn: 'root' })
export class EquipmentClassFacade extends EquipClassFacadeBase {
  constructor(private store: Store<AppState>) {
    super(EquipmentClass, store);
  }

  all$ = this.store.pipe(
    select(equipClassSelectors.selectAll),
    map(equipClasses =>
      equipClasses.sort((a, b) => (a.delta > b.delta ? 1 : -1))
    )
  );

  get currentClassTypes$(): Observable<EquipmentType[]> {
    return this.store.pipe(
      select(currentEquipClassTypes),
      map(equipTypes => equipTypes.sort((a, b) => (a.delta > b.delta ? 1 : -1)))
    );
  }

  get allVM$(): Observable<EquipmentClassVM[]> {
    return this.store.pipe(select(equipmentClassVM));
  }
}
